


import React, { useEffect, useRef, useState, useContext } from "react";
import "../css/layout.css";
import css from "../Modulecss/Home.module.css";
import axios from "axios";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Rightcontainer from "../Components/Rightcontainer";
import { useDispatch } from "react-redux";
import BetCard from "./BetCard";
import RunningCard from "./RunningCard";
import Header from "../Components/Header";
import io from "../Components/socket";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import guidebutton from "../../assets/images/guidebutton.png";
import socket from "../Components/socket";
import acceptSound from "./accept.mp3";
import findGif from "../css/loading_old.gif";
import playSound from "./accept.mp3";
import { MdOutlineDelete } from "react-icons/md";
import { FiRefreshCcw } from "react-icons/fi";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { apiRequest } from "../../apiService/allApi";

export default function Homepage({ rungame, homePlay, users }) {
  // BASE URL
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  let baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

  const history = useHistory();
  let userID = useRef();
  const isMounted = useRef(true);
  let str;

  const [user, setUser] = useState();
  const [create, setCreated] = useState([]);
  const [challangeReqRun, setChallangeReqRun] = useState(false);
  const [game_amount, setGame_amt] = useState();
  const [gameData, setGameData] = useState({});
  const [submitProcess, setProcess] = useState(true);
  const [isLoading, setIsloading] = useState(false);
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);
  const userId = localStorage.getItem("userId");
  const access_token = localStorage.getItem("token");
  const [disable, setDisable] = React.useState(challangeReqRun);
  const [disable_play, setDisable_play] = React.useState(false);
  const [GameList, setGameList] = useState(homePlay);
  console.log(GameList, "GameList");

  const req_chall_fun = (allgameId) => {
    getPost(allgameId);
  };

  const disablebtn = (id) => {
    setDisable(true);
    setTimeout(() => {
      setDisable(false);
    }, 10000);
  };

  const disable_play_btn = () => {
    setDisable_play(true);
    setTimeout(() => {
      setDisable_play(false);
    }, 3000);
  };

  const [game_type, setGame_type] = useState(
    useLocation().pathname.split("/")[2]
  );
  const [game_type2, setGame_type2] = useState(
    useLocation().pathname.split("/")[3]
  );
  const [Game_Ammount, setGame_Ammount] = useState("");

  const ChallengeCreate = async (e) => {
    setIsloading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    if (game_type == "ludoClassicManual") {
      if (Game_Ammount >= 50 && Game_Ammount <= 50000) {
        try {
          const res = await apiRequest(`challange/create`, "POST", { Game_Ammount, Game_type: game_type, }, headers);
          setGame_amt(res?.data?.data?.Game_Ammount);

          if (res.data.status == false) {
            setIsloading(false);
            Swal.fire({ title: res.data.msg, icon: "warning", confirmButtonText: "OK" });
          } else if (res.data.msg === "you have already enrolled") {
            setIsloading(false);
            Swal.fire({ title: "You have already enrolled", icon: "warning", confirmButtonText: "OK" });
          } else if (res.data.msg === "You can set maximum 2 battle.") {
            setIsloading(false);
            Swal.fire({ title: "You can set maximum 2 battle.", icon: "warning", confirmButtonText: "OK" });
          } else if (res.data.msg === "Insufficient balance") {
            setIsloading(false);
            Swal.fire({ title: "Insufficient balance", icon: "warning", confirmButtonText: "OK" });
          } else if (res.data.msg === "Game amount should be Greater then 50 and less then 50000") {
            setIsloading(false);
            Swal.fire({ title: "Game amount should be Greater then 50 and less then 50000", icon: "warning", confirmButtonText: "OK" });
          } else if (res.data.msg === "Set Battle in denomination of 50") {
            setIsloading(false);
            Swal.fire({ title: "Set Battle in denomination of 50", icon: "warning", confirmButtonText: "OK" });
          } else if (res.data.msg === "Technical Issue, Try after an hour!") {
            setIsloading(false);
            Swal.fire({ title: "Technical Issue, Try after an hour!", icon: "warning", confirmButtonText: "OK" });
          } else {
            setIsloading(false);
          }
        } catch (e) {
          setIsloading(false);
          if (e?.response?.status == 401) {
            localStorage.removeItem("token");
            window.location.reload();
          }
          if (e?.response?.status == 400 || e?.response?.status == 429) {
            Swal.fire({ title: "Please refresh!", icon: "warning", confirmButtonText: "OK" });
          }
          console.log(e);
        }
      } else {
        setIsloading(false);
        Swal.fire({ title: "Please Amount should be greater 50 and less 50000!", icon: "warning", confirmButtonText: "OK" });
      }
    } else if (game_type == "ludoClassicRich") {
      if (Game_Ammount >= 550 && Game_Ammount <= 200000) {
        try {
          const res = await apiRequest(`challange/create`, "POST", { Game_Ammount, Game_type: game_type, }, headers);
          setGame_amt(res?.data?.data?.Game_Ammount);

          if (res.data.status == false) {
            setIsloading(false);
            Swal.fire({ title: res.data.msg, icon: "warning", confirmButtonText: "OK" });
          } else if (res.data.msg === "you have already enrolled") {
            setIsloading(false);
            Swal.fire({ title: "You have already enrolled", icon: "warning", confirmButtonText: "OK" });
          } else if (res.data.msg === "You can set maximum 2 battle.") {
            setIsloading(false);
            Swal.fire({ title: "You can set maximum 2 battle.", icon: "warning", confirmButtonText: "OK" });
          } else if (res.data.msg === "Insufficient balance") {
            setIsloading(false);
            Swal.fire({ title: "Insufficient balance", icon: "warning", confirmButtonText: "OK" });
          } else if (res.data.msg === "Game amount should be Greater then 50 and less then 50000") {
            setIsloading(false);
            Swal.fire({ title: "Game amount should be Greater then 50 and less then 50000", icon: "warning", confirmButtonText: "OK" });
          } else if (res.data.msg === "Set Battle in denomination of 50") {
            setIsloading(false);
            Swal.fire({ title: "Set Battle in denomination of 50", icon: "warning", confirmButtonText: "OK" });
          } else if (res.data.msg === "Technical Issue, Try after an hour!") {
            setIsloading(false);
            Swal.fire({ title: "Technical Issue, Try after an hour!", icon: "warning", confirmButtonText: "OK" });
          } else {
            setIsloading(false);
          }
        } catch (e) {
          setIsloading(false);
          if (e?.response?.status == 401) {
            localStorage.removeItem("token");
            window.location.reload();
          }
          if (e?.response?.status == 400 || e?.response?.status == 429) {
            Swal.fire({ title: "Please refresh!", icon: "warning", confirmButtonText: "OK" });
          }
          console.log(e);
        }
      } else {
        setIsloading(false);
        Swal.fire({ title: "Please Amount should be greater 550 and less 200000!", icon: "warning", confirmButtonText: "OK" });
      }
    } else {
      try {
        const res = await apiRequest(`challange/create`, "POST", { Game_Ammount, Game_type: game_type }, headers);
        setGame_amt(res?.data?.data?.Game_Ammount);

        if (res.data.status == false) {
          setIsloading(false);
          Swal.fire({ title: res.data.msg, icon: "warning", confirmButtonText: "OK" });
        } else if (res.data.msg === "you have already enrolled") {
          setIsloading(false);
          Swal.fire({ title: "You have already enrolled", icon: "warning", confirmButtonText: "OK" });
        } else if (res.data.msg === "You can set maximum 2 battle.") {
          setIsloading(false);
          Swal.fire({ title: "You can set maximum 2 battle.", icon: "warning", confirmButtonText: "OK" });
        } else if (res.data.msg === "Insufficient balance") {
          setIsloading(false);
          Swal.fire({ title: "Insufficient balance", icon: "warning", confirmButtonText: "OK" });
        } else if (res.data.msg === "Game amount should be Greater then 50 and less then 50000") {
          setIsloading(false);
          Swal.fire({ title: "Game amount should be Greater then 50 and less then 50000", icon: "warning", confirmButtonText: "OK" });
        } else if (res.data.msg === "Set Battle in denomination of 50") {
          setIsloading(false);
          Swal.fire({ title: "Set Battle in denomination of 50", icon: "warning", confirmButtonText: "OK" });
        } else if (res.data.msg === "Technical Issue, Try after an hour!") {
          setIsloading(false);
          Swal.fire({ title: "Technical Issue, Try after an hour!", icon: "warning", confirmButtonText: "OK" });
        } else {
          setIsloading(false);
        }
      } catch (e) {
        setIsloading(false);
        if (e?.response?.status == 401) {
          localStorage.removeItem("token");
          window.location.reload();
        }
        if (e.response.status == 400 || e.response.status == 429) {
          Swal.fire({ title: "Please refresh!", icon: "warning", confirmButtonText: "OK" });
        }
        console.log(e);
      }
    }
  };

  const [MyopenBattle, setMyOpenBattle] = useState([]);
  const [OtheropenBattle, setOtherMyOpenBattle] = useState([]);
  const [MyrunningBattle, setMyRunningBattle] = useState([]);
  const [OtherrunningBattle, setOtherRunningBattle] = useState([]);

  useEffect(() => {
    socket.emit("getgamelist", userId);
    socket.on("setGamelist", (data) => {
      setGameList(data);
    });
  }, []);

  useEffect(() => {
    io.on("gameCreate", (data) => {
      if (data?.Accepetd_By?._id === userId || data?.Created_by?._id === userId) {
        if (!MyopenBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
        }
      } else {
        if (!OtheropenBattle.some((item) => item._id === data._id)) {
          setOtherMyOpenBattle((OtheropenBattle) => [data, ...OtheropenBattle]);
        }
      }
    });
    io.on("deletebat", (data) => {
      setMyOpenBattle((MyopenBattle) => MyopenBattle.filter((item) => item._id !== data));
      setOtherMyOpenBattle((OtheropenBattle) => OtheropenBattle.filter((item) => item._id !== data));
    });

    io.on("gameUpdate", (data) => {
      setMyOpenBattle((MyopenBattle) => MyopenBattle.filter((item) => item?._id !== data?._id));
      setOtherMyOpenBattle((OtheropenBattle) => OtheropenBattle.filter((item) => item?._id !== data?._id));
      if (data?.Accepetd_By?._id === userId || data?.Created_by?._id === userId) {
        if (!MyopenBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
        }
      } else {
        if (!OtheropenBattle.some((item) => item._id === data._id)) {
          setOtherMyOpenBattle((OtheropenBattle) => [data, ...OtheropenBattle]);
        }
      }
    });

    io.on("startAccepted", (data) => {
      setMyOpenBattle((MyopenBattle) => MyopenBattle.filter((item) => item?._id !== data?._id));
      setOtherMyOpenBattle((OtheropenBattle) => OtheropenBattle.filter((item) => item?._id !== data?._id));

      if (data.Status === "running" && data?.Created_by?._id === userId) {
        if (!MyrunningBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyrunningBattle) => [...MyrunningBattle, data]);
        }
      } else if (data.Status === "running" && data?.Accepetd_By?._id === userId) {
        if (!MyopenBattle?.some((item) => item?._id === data?._id)) {
          setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
        }
      } else {
        if (!OtherrunningBattle?.some((item) => item?._id === data?._id)) {
          setOtherRunningBattle((OtherrunningBattle) => [data, ...OtherrunningBattle]);
        }
      }
    });

    io.on("acceptor_seen_game", (data) => {
      setMyOpenBattle((MyopenBattle) => MyopenBattle?.filter((item) => item?._id !== data?._id));
      setOtherMyOpenBattle((OtheropenBattle) => OtheropenBattle?.filter((item) => item?._id !== data?._id));

      if (data?.Accepetd_By?._id === userId || data?.Created_by?._id === userId) {
        if (!MyrunningBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyrunningBattle) => [...MyrunningBattle, data]);
        }
      }
    });
    io.on("challangeAccept", (data) => {
      setMyOpenBattle((MyopenBattle) => MyopenBattle?.filter((item) => item._id !== data._id));
      setOtherMyOpenBattle((OtheropenBattle) => OtheropenBattle?.filter((item) => item._id !== data._id));

      if (data?.Accepetd_By?._id === userId || data?.Created_by?._id === userId) {
        if (!MyrunningBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyrunningBattle) => [...MyrunningBattle, data]);
        }
      }
    });
  }, [io]);

  function winnAmount(gameAmount) {
    let profit = null;
    if (gameAmount >= 50 && gameAmount <= 250)
      profit = (gameAmount * addCaseSetting?.commissionRange1) / 100;
    else if (gameAmount > 250 && gameAmount <= 500)
      profit = addCaseSetting?.commissionRange2;
    else if (gameAmount > 500)
      profit = (gameAmount * addCaseSetting?.commissionRange3) / 100;
    return gameAmount - profit;
  }

  useEffect(() => {
    let owenedCreated = [];
    let remainingGame = [];

    GameList?.openBattle?.forEach(function (ele) {
      if (ele)
        if (
          (ele?.Created_by?._id == userId || ele?.Accepetd_By?._id == userId) &&
          (ele?.Status == "new" || ele?.Status == "requested")
        ) {
          owenedCreated.push(ele);
        } else if (ele?.Status == "new") {
          remainingGame.push(ele);
        } else if (
          ele?.Status == "running" &&
          ele?.Accepetd_By?._id == userId &&
          ele?.Acceptor_seen === false
        ) {
          owenedCreated.push(ele);
        }
    });
    setMyOpenBattle(owenedCreated);
    setOtherMyOpenBattle(remainingGame);
    let owenedRunning = [];
    let remainingRunning = [];
    GameList?.runningBattle?.forEach(function (ele) {
      if (ele.Created_by && ele.Accepetd_By)
        if (ele.Created_by?._id == userId || ele.Accepetd_By?._id == userId) {
          owenedRunning.push(ele);
        } else {
          remainingRunning.push(ele);
        }
    });
    setMyRunningBattle(owenedRunning);
    setOtherRunningBattle(remainingRunning);
  }, [GameList]);

  useEffect(() => {
    io.on("resultUpdateReq1", (data) => {
      setMyOpenBattle((MyopenBattle) => MyopenBattle?.filter((item) => item?._id !== data?._id));

      if (data.Status === "cancelled" || data.Status === "completed") {
        setMyRunningBattle((MyrunningBattle) => MyrunningBattle?.filter((item) => item?._id !== data?._id));
        setOtherRunningBattle((OtherrunningBattle) => OtherrunningBattle?.filter((item) => item?._id !== data?._id));
      } else {
        const isUserOwned = data?.Created_by?._id === userId || data?.Accepetd_By?._id === userId;

        setMyRunningBattle((MyrunningBattle) => {
          const updatedowenedRunning = MyrunningBattle?.filter((item) => item?._id !== data?._id);
          if (isUserOwned) {
            updatedowenedRunning.push(data);
          }
          return updatedowenedRunning;
        });

        setOtherRunningBattle((OtherrunningBattle) => {
          const updatedrunningGames = OtherrunningBattle?.filter((item) => item?._id !== data?._id);
          if (!isUserOwned) {
            updatedrunningGames.push(data);
          }
          return updatedrunningGames;
        });
      }
    });
  }, [io, userId]);

  useEffect(() => {
    let access_token = localStorage.getItem("token");
    if (!access_token) {
      window.location.reload();
    }
  }, []);

  const RunningGames = async () => {
    const access_tokena = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    try {
      const res = await apiRequest(`challange/running/all`, "GET", null, headers);
      let owenedRunning = [];
      let remainingRunning = [];
      res?.data?.forEach(function (ele) {
        if (ele.Created_by && ele.Accepetd_By)
          if (ele.Created_by?._id == userId || ele.Accepetd_By?._id == userId) {
            owenedRunning.push(ele);
          } else {
            remainingRunning.push(ele);
          }
      });
      setMyRunningBattle(owenedRunning);
      setOtherRunningBattle(remainingRunning);
    } catch (e) {
      console.log("errror", e);
    }
  };

  const AcceptChallang = async (id) => {
    if (str == 1) {
      Swal.fire({ title: "Other request in process", icon: "warning", confirmButtonText: "OK" });
    }
    str = 1;
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    try {
      const res = await apiRequest(`challange/accept/${id}`, "PUT", { Accepetd_By: headers, Acceptor_by_Creator_at: Date.now() }, headers);
      setGameData({
        accept_by: res.data.Accepetd_By,
        created_by: res.data.Created_by,
      });

      str = 0;
      if (res.data.status === false) {
        Swal.fire({ title: res.data.msg, icon: "warning", confirmButtonText: "OK" });
      }
      if (res.data.msg === "you have already enrolled") {
        Swal.fire({ title: "You have already enrolled", icon: "warning", confirmButtonText: "OK" });
      }
      if (res.data.msg === "Insufficient balance") {
        Swal.fire({ title: "Insufficient balance", icon: "warning", confirmButtonText: "OK" });
      }
      if (res.data.msg === "Game already start with other player") {
        Swal.fire({ title: res.data.msg, icon: "warning", confirmButtonText: "OK" });
      }
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        window.location.reload();
      }
      if (e.response.status == 400) {
        Swal.fire({ title: e.response.data, icon: "warning", confirmButtonText: "OK" });
      }
      if (e.response.status == 429) {
        Swal.fire({ title: "Please refresh!", icon: "warning", confirmButtonText: "OK" });
      }
    }
  };

  const RejectGame = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    try {
      const res = await apiRequest(`challange/reject/${id}`, "PUT", { Accepetd_By: null, Status: "new", Acceptor_by_Creator_at: null, }, headers);
    } catch (e) {
      console.log(e);
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        window.location.reload();
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({ title: "Please refresh!", icon: "warning", confirmButtonText: "OK" });
      }
    }
  };

  const deleteChallenge = async (_id) => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    try {
      const res = await apiRequest(`challange/delete/${_id}`, "DELETE", null, headers);
      if (res.data.status == false) {
        Swal.fire({ title: res.data.msg, icon: "warning", confirmButtonText: "OK" });
      }
    } catch (e) {
      if (e?.response?.status == 401) {
        localStorage.removeItem("token");
        window.location.reload();
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({ title: "Please refresh!", icon: "warning", confirmButtonText: "OK" });
      }
    }
  };

  const updateChallenge = async (_id) => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    try {
      const res = await apiRequest(`challange/running/update/${_id}`, "PUT", { Acceptor_seen: true, }, headers);
      if (res) {
        localStorage.setItem("timeOver", "timeStart");
      }
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        window.location.reload();
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({ title: "Please refresh!", icon: "warning", confirmButtonText: "OK" });
      }
      console.log(e);
    }
  };

  const getPost = async (Id) => {
    if (
      game_type === "Ludo Classics" ||
      game_type === "Ludo 1 Goti" ||
      game_type === "Ludo Ulta" ||
      game_type === "Prime Ludo" ||
      game_type === "Ludo Host"
    ) {
      if (submitProcess) {
        setProcess(false);
        setChallangeReqRun(true);
        const access_token = localStorage.getItem("token");
        const headers = { authorization: `Bearer ${access_token}` };

        try {
          const res = await apiRequest(`challange/requested/running/${game_type}/` + Id, "PATCH", null, headers);
          setProcess(true);
          setChallangeReqRun(false);
          if (res.data.status == false) {
            Swal.fire({ title: res.data.msg, icon: "warning", confirmButtonText: "OK" });
          } else {
            history.push(`/viewgame1/${Id}`, { prevPath: window.location?.pathname });
          }
        } catch (e) {
          setProcess(true);
          setChallangeReqRun(false);
          if (e?.response?.status == 401) {
            Swal.fire({ title: "Somthing wrong", icon: "warning", confirmButtonText: "OK" });
          } else {
            Swal.fire({ title: "Please refresh!", icon: "warning", confirmButtonText: "OK" });
          }
        }
      }
    } else if (
      game_type === "LudoSnake" ||
      game_type === "LudoPopular" ||
      game_type === "ludoClassicManual" ||
      game_type === "ludoClassicRich"
    ) {
      if (submitProcess) {
        setProcess(false);
        setChallangeReqRun(true);
        const access_token = localStorage.getItem("token");
        const headers = { authorization: `Bearer ${access_token}` };

        try {
          const res = await apiRequest("challange/requested/running/" + Id, "PATCH", {}, headers);
          setProcess(true);
          setChallangeReqRun(false);

          if (res.data.status == false) {
            Swal.fire({ title: res.data.msg, icon: "warning", confirmButtonText: "OK" });
          } else {
            history.push(`/viewgame1/${Id}`, { prevPath: window.location?.pathname });
          }
        } catch (e) {
          setProcess(true);
          setChallangeReqRun(false);
          if (e?.response?.status == 401) {
            Swal.fire({ title: "Somthing wrong", icon: "warning", confirmButtonText: "OK" });
          } else {
            Swal.fire({ title: "Please refresh!", icon: "warning", confirmButtonText: "OK" });
          }
        }
      }
    }
  };

  const handleButtonClick = (gameType) => {
    setGame_type(gameType);
  };

  const GameModeChange = () => {
    socket.on("setGamelist", (modeData) => {
      setGameList(modeData);
    });
  };

  const translations = {
    hi: {
      gameadd: 'गेम बनाये !',
      gameset: 'लगाये',
      openGame: 'खुला गेम ',
      challange: 'चुनोती देने वाला  ',
      entry: 'प्रवेश शुल्क',
      prize: 'इनाम',
      play: 'खेले ',
      running: 'चल रहे गेम ',
      start: 'चालू',
      cancel: 'रद्द करें',
    },
    en: {
      gameadd: 'Create a Battle!',
      gameset: 'Set',
      openGame: 'Open Battles',
      challange: 'Challange From  ',
      entry: 'ENTRY FEE',
      prize: 'PRIZE',
      play: 'Play',
      running: 'Running Battles',
      start: 'Start',
      cancel: 'Decline',
    },
  };

  const { language } = useContext(LanguageContext);

  return (
    <>
      <Header user={users} />
      <div className={`leftContainer mt-5 pt-5 ${css.homeWrapper}`}>
        {/* Ambient background glows */}
        <div className={css.ambientGlow1}></div>
        <div className={css.ambientGlow2}></div>

        <div className={css.homeContentInner}>
          {(() => {
            const sitSettingRaw = localStorage.getItem("sitSetting");
            if (!sitSettingRaw || sitSettingRaw === "undefined") return null;

            const sitSetting = JSON.parse(sitSettingRaw);
            const manualMsg = sitSetting?.ludoClassicManualMsg;
            const autoMsg = sitSetting?.ludoClassicAutoMsg;
            const showMessage = game_type === "LudoSnake" ? manualMsg : autoMsg;

            if (!showMessage) return null;

            return (
              <div className={css.alertMessageCard}>
                <div className={css.alertMessageInner}>
                  <h5>{showMessage}</h5>
                </div>
              </div>
            );
          })()}

          <div>
            {/* Create a Battle */}
            {JSON.parse(localStorage.getItem("sitSetting")) == "undefined" ? (
              ""
            ) : JSON.parse(localStorage.getItem("sitSetting"))?.gameSearch == true ? (
              <>
                <div className={`${css.battleBx} position-relative`}>
                  <span className={css.otherPageSmallHeadings}>
                    {translations[language].gameadd}
                  </span>
                  <span
                    className={`${css.gamesSectionHeadline} info text-uppercase position-absolute font-weight-bold`}
                    style={{ right: "12px", top: "12px" }}
                  >
                    Rules
                    <NavLink to="/Rules">
                      <img
                        className="ml-2"
                        src={process.env.PUBLIC_URL + "/images/Homepage/info.png"}
                        alt="info"
                        width="14px"
                      />
                    </NavLink>
                  </span>

                  {addCaseSetting.gameSearch && game_type2 !== "new" && (
                    <div className={`${css.battleCreateWrapper} mt-2`}>
                      {/* Input Box Frame with Animated Beams */}
                      <div className={css.animatedInputFrame}>
                        <svg className={css.svgBorderOverlay} width="100%" height="100%">
                          <defs>
                            <linearGradient id="beamGradientTop" x1="0%" y1="0%" x2="100%" y2="100%">
                              <stop offset="0%" stopColor="#0082cd" />
                              <stop offset="100%" stopColor="#61b233" />
                            </linearGradient>

                            <linearGradient id="beamGradientBottom" x1="0%" y1="0%" x2="100%" y2="100%">
                              <stop offset="0%" stopColor="#ffcd00" />
                              <stop offset="100%" stopColor="#0082cd" />
                            </linearGradient>
                          </defs>

                          <rect
                            x="1"
                            y="1"
                            width="calc(100% - 2px)"
                            height="calc(100% - 2px)"
                            rx="10"
                            fill="none"
                            stroke="#e2e8f0"
                            strokeWidth="1.5"
                          />

                          <rect
                            className={`${css.beamPath} ${css.movingBeamTop}`}
                            x="1"
                            y="1"
                            width="calc(100% - 2px)"
                            height="calc(100% - 2px)"
                            rx="10"
                            fill="none"
                            stroke="url(#beamGradientTop)"
                            strokeWidth="2.5"
                          />

                          <rect
                            className={`${css.beamPath} ${css.movingBeamBottom}`}
                            x="1"
                            y="1"
                            width="calc(100% - 2px)"
                            height="calc(100% - 2px)"
                            rx="10"
                            fill="none"
                            stroke="url(#beamGradientBottom)"
                            strokeWidth="2.5"
                          />
                        </svg>

                        <div className={css.inputContentInner}>
                          <input
                            className={css.customBattleInput}
                            type="tel"
                            placeholder="Enter Amount"
                            value={Game_Ammount}
                            onChange={(e) => setGame_Ammount(e.target.value)}
                          />
                          <span className={css.rupeeSymbol}>₹</span>
                        </div>
                      </div>

                      {/* SET Button */}
                      {!isLoading ? (
                        <button
                          className={css.animatedSetBtn}
                          onClick={(e) => {
                            e.preventDefault();
                            ChallengeCreate();
                          }}
                        >
                          {translations[language].gameset}
                        </button>
                      ) : (
                        <button className={css.animatedSetBtn} disabled style={{ opacity: 0.8 }}>
                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </>
            ) : (
              ""
            )}

            <div className="py-2">
              <div className={`${css.openBattleHeadings} mb-2`}>
                <img src={process.env.PUBLIC_URL + "/images/crossswords.png"} alt="swords" width="24px" />
                <span className={`ms-2 ${css.gamesSectionTitle}`}>
                  {translations[language].openGame}
                </span>
              </div>

              {/* MY OPEN BATTLES LIST */}
              {MyopenBattle &&
                MyopenBattle.filter((allgame) => allgame?.Game_type === game_type).map(
                  (allgame, index) => (
                    <div key={allgame?._id || index} className={css.battleCard}>
                      <div className={css.battleCardHeader}>
                        <span className={css.challengeTitle}>
                          {translations[language].challange}{" "}
                          <span className={css.challengerName}>
                            {allgame.Created_by?.Name.length > 12
                              ? `${allgame.Created_by?.Name.slice(0, 12)}...`
                              : allgame.Created_by?.Name}
                          </span>
                        </span>
                      </div>

                      <div className={css.battleCardBody}>
                        <div className={`${css.infoColumn} text-start`}>
                          <span className={css.infoLabel}>
                            {translations[language].entry}
                          </span>
                          <div className={css.infoValueRow}>
                            <img
                              src="/images/moneyrupee.png"
                              alt="cash"
                              className={css.currencyIcon}
                            />
                            <span className={css.infoAmount}>
                              {allgame?.Game_Ammount}
                            </span>
                          </div>
                        </div>

                        <div className={css.actionColumn}>
                          {userId == allgame?.Created_by?._id &&
                            allgame?.Status == "new" && (
                              <div className={css.loaderBox}>
                                <img
                                  src="/images/LandingPage_img/loader1.gif"
                                  alt="loading"
                                  className={css.loaderGif}
                                />
                              </div>
                            )}

                          {userId &&
                            allgame &&
                            userId !== allgame?.Created_by?._id &&
                            allgame?.Status == "new" && (
                              <button
                                className={css.btnPurplePlay}
                                disabled={disable_play}
                                onClick={() => {
                                  disable_play_btn();
                                  AcceptChallang(allgame?._id);
                                }}
                              >
                                {translations[language].play}
                              </button>
                            )}

                          {userId == allgame?.Created_by?._id &&
                            allgame?.Status == "new" && (
                              <button
                                className={css.btnDangerSm}
                                onClick={() => deleteChallenge(allgame?._id)}
                              >
                                Delete
                              </button>
                            )}

                          {userId !== allgame?.Created_by?._id &&
                            allgame?.Status == "requested" && (
                              <div className={css.statusBadgeGroup}>
                                <span className={css.badgeRequested}>requested</span>
                                <button
                                  className={css.btnOutlineCancel}
                                  onClick={() => RejectGame(allgame?._id)}
                                >
                                  cancel
                                </button>
                              </div>
                            )}

                          {userId &&
                            allgame &&
                            userId !== allgame?.Created_by?._id &&
                            allgame?.Status == "running" && (
                              <div>
                                <audio src={playSound} autoPlay></audio>
                                <button
                                  disabled={disable}
                                  className={css.btnSuccessStart}
                                  onClick={(e) => {
                                    disablebtn();
                                    updateChallenge(allgame?._id);
                                    history.push(`/viewgame1/${allgame?._id}`, {
                                      prevPath: window.location.pathname,
                                    });
                                  }}
                                >
                                  {translations[language].start}
                                </button>
                              </div>
                            )}

                          {userId == allgame?.Created_by?._id &&
                            allgame.Status == "requested" && (
                              <div className={css.statusBadgeGroup}>
                                <audio src={acceptSound} autoPlay></audio>
                                {!disable && (
                                  <button
                                    className={css.btnSuccessStart}
                                    disabled={disable}
                                    onClick={(e) => {
                                      disablebtn(allgame?._id);
                                      req_chall_fun(allgame?._id);
                                    }}
                                  >
                                    {translations[language].start}
                                  </button>
                                )}
                                {disable && (
                                  <button className={css.btnSecondaryWait}>Wait</button>
                                )}
                                <button
                                  className={css.btnDangerSm}
                                  onClick={() => RejectGame(allgame?._id)}
                                >
                                  {translations[language].cancel}
                                </button>
                              </div>
                            )}
                        </div>

                        <div className={`${css.infoColumn} text-end`}>
                          <span className={css.infoLabel}>
                            {translations[language].prize}
                          </span>
                          <div className={`${css.infoValueRow} justify-content-end`}>
                            <img
                              src="/images/moneyrupee.png"
                              alt="cash"
                              className={css.currencyIcon}
                            />
                            <span className={css.infoAmount}>
                              {allgame?.Game_Ammount +
                                winnAmount(allgame?.Game_Ammount)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                )}

              {/* OTHER OPEN BATTLES LIST */}
              {OtheropenBattle &&
                OtheropenBattle.filter((allgame) => allgame?.Game_type === game_type).map(
                  (allgame, index) => (
                    <div key={allgame?._id || index} className={css.battleCard}>
                      <div className={css.battleCardHeader}>
                        <span className={css.challengeTitle}>
                          {translations[language].challange}{" "}
                          <span className={css.challengerName}>
                            {allgame.Created_by?.Name.length > 12
                              ? `${allgame.Created_by?.Name.slice(0, 12)}...`
                              : allgame.Created_by?.Name}
                          </span>
                        </span>
                      </div>

                      <div className={css.battleCardBody}>
                        <div className={`${css.infoColumn} text-start`}>
                          <span className={css.infoLabel}>
                            {translations[language].entry}
                          </span>
                          <div className={css.infoValueRow}>
                            <img
                              src="/images/moneyrupee.png"
                              alt="cash"
                              className={css.currencyIcon}
                            />
                            <span className={css.infoAmount}>
                              {allgame?.Game_Ammount}
                            </span>
                          </div>
                        </div>

                        <div className={css.actionColumn}>
                          {userId == allgame?.Created_by?._id &&
                            allgame?.Status == "new" && (
                              <button
                                className={css.btnDangerSm}
                                onClick={() => deleteChallenge(allgame?._id)}
                              >
                                Delete
                              </button>
                            )}

                          {userId == allgame?.Created_by?._id &&
                            allgame?.Status == "requested" && (
                              <div className={css.statusBadgeGroup}>
                                {!disable && (
                                  <button
                                    className={css.btnSuccessStart}
                                    disabled={disable}
                                    onClick={(e) => {
                                      disablebtn(allgame?._id);
                                      req_chall_fun(allgame?._id);
                                    }}
                                  >
                                    {translations[language].start}
                                  </button>
                                )}
                                {disable && (
                                  <button className={css.btnSecondaryWait}>Wait</button>
                                )}
                                <button
                                  className={css.btnDangerSm}
                                  onClick={() => RejectGame(allgame?._id)}
                                >
                                  {translations[language].cancel}
                                </button>
                              </div>
                            )}

                          {userId &&
                            allgame &&
                            userId !== allgame?.Created_by?._id &&
                            allgame?.Status == "new" && (
                              <button
                                className={css.btnPurplePlay}
                                disabled={disable_play}
                                onClick={() => {
                                  disable_play_btn();
                                  AcceptChallang(allgame?._id);
                                }}
                              >
                                {translations[language].play}
                              </button>
                            )}

                          {userId == allgame?.Created_by?._id &&
                            allgame?.Status == "new" && (
                              <div className={css.loaderBox}>
                                <img
                                  src="/images/LandingPage_img/loader1.gif"
                                  alt="loading"
                                  className={css.loaderGif}
                                />
                              </div>
                            )}

                          {userId !== allgame?.Created_by?._id &&
                            allgame?.Status == "requested" && (
                              <div className={css.statusBadgeGroup}>
                                <span className={css.badgeRequested}>requested</span>
                                <button
                                  className={css.btnOutlineCancel}
                                  onClick={() => RejectGame(allgame?._id)}
                                >
                                  cancel
                                </button>
                              </div>
                            )}

                          {userId &&
                            userId !== allgame?.Created_by?._id &&
                            allgame?.Status == "running" && (
                              <div>
                                <audio src={playSound} autoPlay></audio>
                                <button
                                  disabled={disable}
                                  className={css.btnSuccessStart}
                                  onClick={(e) => {
                                    disablebtn();
                                    updateChallenge(allgame?._id);
                                    history.push(`/viewgame1/${allgame?._id}`, {
                                      prevPath: window.location.pathname,
                                    });
                                  }}
                                >
                                  {translations[language].start}
                                </button>
                              </div>
                            )}
                        </div>

                        <div className={`${css.infoColumn} text-end`}>
                          <span className={css.infoLabel}>
                            {translations[language].prize}
                          </span>
                          <div className={`${css.infoValueRow} justify-content-end`}>
                            <img
                              src="/images/moneyrupee.png"
                              alt="cash"
                              className={css.currencyIcon}
                            />
                            <span className={css.infoAmount}>
                              {allgame?.Game_Ammount +
                                winnAmount(allgame?.Game_Ammount)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                )}
            </div>

            <div className={css.battleDivider}></div>

            <div className="mb-4">
              <div className={css.openBattleHeadings}>
                <img src={process.env.PUBLIC_URL + "/images/Homepage/battleIcon.png"} alt="battle" width="20px" />
                <span className={`ms-2 ${css.gamesSectionTitle}`}>
                  {translations[language].running}
                </span>
              </div>

              {MyrunningBattle && MyrunningBattle.map((runnig) => {
                if (
                  ((userId == runnig.Accepetd_By._id
                    ? (runnig.Status === "running" &&
                      userId == runnig.Accepetd_By._id &&
                      runnig.Acceptor_seen == true) ||
                    runnig.Status === "pending"
                    : (runnig.Status === "running" &&
                      userId == runnig.Created_by._id) ||
                    runnig.Status === "pending") ||
                    runnig.Status == "conflict") &&
                  (runnig?.Game_type == game_type ||
                    runnig?.Game_type == "ludoClassicManual" ||
                    runnig?.Game_type == "ludoClassicRich" || runnig?.Game_type == "LudoPopular")
                )
                  return (
                    <RunningCard
                      key={runnig._id}
                      runnig={runnig}
                      user={users}
                      winnAmount={winnAmount}
                    />
                  );
              })}

              {OtherrunningBattle && OtherrunningBattle.map((runnig) => {
                if (
                  (userId == runnig?.Accepetd_By?._id ||
                    userId == runnig?.Created_by?._id
                    ? userId == runnig.Accepetd_By._id
                      ? (runnig.Status === "running" &&
                        userId == runnig.Accepetd_By._id &&
                        runnig.Acceptor_seen == true) ||
                      (runnig.Status === "pending" &&
                        runnig.Acceptor_status == null)
                      : (runnig.Status === "running" &&
                        user == runnig.Created_by._id) ||
                      (runnig.Status === "pending" &&
                        runnig.Creator_Status == null)
                    : runnig.Status === "running" ||
                    runnig.Status === "pending") &&
                  (runnig?.Game_type == game_type ||
                    game_type == "ludoClassicManual" ||
                    game_type == "ludoClassicRich")
                )
                  return (
                    <React.Fragment key={runnig._id}>
                      <RunningCard
                        runnig={runnig}
                        user={users}
                        winnAmount={winnAmount}
                      />
                    </React.Fragment>
                  );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
}